'use strict';

// Debug-Logging fuer alle HTTP-Requests (loggt rohe Server-Antworten in die Konsole).
// ACHTUNG: VOR PRODUKTIONS-DEPLOY auf false setzen (siehe Deploy-Checkliste in CLAUDE.md).
const HTTP_DEBUG = false;

var _HttpRequest = {
    options: {
        url: "",
        type: "GET",
        async: true,
        data: null,
        format: "json",
        output: "json"
    },
    send(params) {
        window.dispatchEvent(new Event("sendrequest"));
        this.options = Object.assign({}, this.options, params);

        if (this.request) {
            this.request.abort();
        }

        this.request = new XMLHttpRequest();

        this.request.addEventListener("loadend", (e) => {
            this._onSuccess(e.target)
        });
        this.request.addEventListener("error", (e) => {
            this._onError(e.target)
        });

        if (this.options.type.toUpperCase() === "POST") {
            this.request.open(this.options.type.toUpperCase(), this.options.url, this.options.async);
            if (this.options.format == "json") {
                this.request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                this.request.send(JSON.stringify(this.options.data));
            } else {
                var form = new FormData();
                if (this.options.data instanceof FormData) {
                    for (var pair of this.options.data.entries()) {
                        if (pair[0] && pair[1] != "null" && pair[1] != "undefined") {
                            form.append(pair[0], pair[1]);
                        }
                    }
                } else {
                    Object.keys(this.options.data).forEach((key) => {
                        if (this.options.data[key] instanceof FormData) {
                            for (var pair of this.options.data[key].entries()) {
                                if (pair[0] && pair[1] != "null" && pair[1] != "undefined") {
                                    form.append(pair[0], pair[1]);
                                }
                            }
                        } else {
                            if (this.options.data[key] != "null" && this.options.data[key] != "undefined") {
                                form.append(key, this.options.data[key]);
                            }
                        }
                    });
                }
                this.request.send(form);
            }
        } else {
            var url = this.options.url;
            if (this.options.data) {
                var data = this.options.data;
                Object.keys(data).forEach((param) => {
                    // var str = param+"="+data[param];
                    url = this.addParameter(url, param, data[param]);
                });
            }
            this.request.open(this.options.type.toUpperCase(), url, this.options.async);
            this.request.send();
        }

        return this;
    },
    _onSuccess(resp) {
        window.dispatchEvent(new Event("donerequest"));
        if (HTTP_DEBUG) {
            console.log("[HttpRequest] DONE", this.options.type, this.options.url,
                "| status:", resp.status, "| raw response:", resp.response);
        }
        if (!!(this._done) && resp.status == 200) {
            if (this.options.output && this.options.output.toUpperCase() == "JSON") {
                try {
                    this._done(JSON.parse(resp.response));
                } catch (e) {
                    if (HTTP_DEBUG) {
                        console.error("[HttpRequest] JSON.parse FEHLGESCHLAGEN fuer", this.options.url,
                            "\n--- ROHE ANTWORT (kein gueltiges JSON, evtl. PHP-Fehlertext) ---\n",
                            resp.response, "\n--- Parse-Error:", e);
                    }
                    this._done(resp);
                }
            } else if (this.options.output && this.options.output.toUpperCase() == "TEXT") {
                this._done(resp.response);
            } else {
                this._done(resp);
            }
        } else {
            this._onError(resp);
        }


    },
    _onError(resp) {
        window.dispatchEvent(new Event("donerequest"));
        if (HTTP_DEBUG) {
            console.warn("[HttpRequest] FAIL", this.options.type, this.options.url,
                "| status:", resp.status, "| raw response:", resp.response);
        }
        if (!!(this._fail)) {
            if (this.options.output && this.options.output.toUpperCase() == "JSON") {
                try {
                    this._fail(JSON.parse(resp.response));
                } catch (e) {
                    this._fail(resp);
                }
            } else if (this.options.output && this.options.output.toUpperCase() == "TEXT") {
                this._fail(resp.response);
            } else {
                this._fail(resp);
            }
        }
    },
    done(call) {
        this._done = call;
        return this;
    },
    fail(call) {
        this._fail = call;
        return this;
    },
    addParameter(url, name, value) {
        const hashurl = url.split("#");
        if (hashurl.length >= 2) {
            url = hashurl[0];
        }
        const urlparts = url.split("?");
        const enc = encodeURIComponent(value);
        if (urlparts.length >= 2) {
            return url + "&" + name + "=" + enc;
        } else {
            return url + "?" + name + "=" + enc;
        }
    },
    getParameterByName(name) {
        return getParameterByNameUrl(name, location.search);
    },
    getParameterByNameUrl(name, url) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(url);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        const urlparts = url.split("?");
        if (urlparts.length >= 2) {

            const prefix = encodeURIComponent(parameter) + "=";
            const pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (let i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + "?" + pars.join("&");
            return url;
        } else {
            return url;
        }
    }
};

function HttpRequest() {
    return Object.create(_HttpRequest);
}

// Escaped Nutzerdaten vor dem Einfuegen in innerHTML (Text- UND Attribut-Kontext).
// read2.php gibt Felder per html_entity_decode() roh zurueck; ohne Escaping waere
// das eine Stored-XSS-Quelle. null/undefined -> "".
function escapeHtml(value) {
    if (value === null || value === undefined) {
        return "";
    }
    return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

class _DOMUtils {
    constructor(elm) {
        if (elm) {
            this.elm = elm;
            this.get(elm);
        }
        return this;
    }
    get(elm) {
        if (typeof elm == "object") {
            this.elm = [elm];
        } else {
            this.elm = document.querySelectorAll(elm);
        }
        return this.elm;
    }
    getElm(maxCount) {
        if (maxCount) {
            const arr = [...this.elm];
            return arr.slice(0, maxCount);
        } else {
            return this.elm[0];
        }

    }
    on(_event, fn) {
        const events = _event.split(" ");
        events.forEach((event) => {
            this.elm.forEach((elm) => {
                if (elm.addEventListener) { // For all major browsers, except IE 8 and earlier
                    elm.addEventListener(event, fn);
                } else if (elm.attachEvent) { // For IE 8 and earlier versions
                    elm.attachEvent(event, fn);
                }
            });
        });
        return this;
    }
    off(_event, fn) {
        if (!_event && !fn) {
            var elms = [];
            this.elm.forEach((elm, idx) => {
                var new_element = elm.cloneNode(true);
                elm.parentNode.replaceChild(new_element, elm);
                elms.push($DOM(new_element).getElm());
            });
            this.elm = elms;
        } else {
            const events = _event.split(" ");
            events.forEach((event) => {
                this.elm.forEach((elm) => {
                    if (elm.removeEventListener) { // For all major browsers, except IE 8 and earlier
                        elm.removeEventListener(event, fn);
                    } else if (elm.detachEvent) { // For IE 8 and earlier versions
                        elm.detachEvent(event, fn);
                    }
                });
            });
        }
        return this.elm;
    }
    onReady(fn) {
        if (document.readyState === "complete") { // Or also compare to "interactive"
            setTimeout(fn, 1); // Schedule to run immediately
        } else {
            var readyStateCheckInterval = setInterval(function () {
                if (document.readyState === "complete") { // Or also compare to "interactive"
                    clearInterval(readyStateCheckInterval);
                    fn();
                }
            }, 10);
        }
    }
    addClass(cls) {
        this.elm.forEach((elm) => {
            elm.classList.add(cls);
        });
    }
    removeClass(cls) {
        this.elm.forEach((elm) => {
            if (!cls) {
                elm.className = "";
            } else {
                elm.classList.remove(cls);
            }
        });
    }
    hasClass(cls) {
        return this.getElm().classList.contains(cls);
    }
    dialog(mode) {
        if (mode == "open") {
            this.removeClass("hidden");
            return true;
        } else if (mode == "isOpen") {
            return !this.hasClass("hidden");
        } else {
            this.addClass("hidden");
            return false;
        }
    }
    html(txt) {
        if (txt != "null" && txt != "undefined") {
            this.elm.forEach((elm) => {
                elm.innerHTML = txt;
            });
            return this;
        } else {
            return this.getElm().innerHTML;
        }
    }
    val(txt) {
        // Setter, sobald ein Wert uebergeben wurde (auch "" oder 0!). Getter nur
        // beim Aufruf ohne Argument (undefined) bzw. null. Frueher war "" falsy ->
        // .val("") wirkte faelschlich als Getter und LEERTE versteckte ID-Felder
        // NICHT (z. B. #data-dataid): nach einem Bearbeiten wurde ein folgendes
        // Anlegen dann zum Update des vorher bearbeiteten Eintrags.
        if (txt !== undefined && txt !== null) {
            this.elm.forEach((elm) => {
                elm.value = txt;
            });
        } else {
            return this.getElm().value;
        }
    }
    checked(value) {
        if (value != "null" && value != "undefined") {
            this.elm.forEach((elm) => {
                elm.checked = value;
            });
        } else {
            return this.getElm().checked;
        }
    }
    append(txt) {
        if (!(typeof (txt) == "string") && txt.elm) {
            this.elm.forEach((elm) => {
                elm.appendChild(txt.getElm());
            });
        } else {
            this.elm.forEach((elm) => {
                elm.insertAdjacentHTML("beforeend", txt);
            });
        }


    }
    empty() {
        this.elm.forEach((elm) => {
            elm.innerHTML = "";
        });
    }
    create(tag) {
        this.elm = [document.createElement(tag)];
        return this;
    }
    attr(attr) {
        return this.getElm().getAttribute(attr);
    }
    parent() {
        return DOMUtils(this.getElm().parentElement);
    }
    remove() {
        this.elm.forEach((elm) => {
            elm.remove();
        });
    }
    clearForm() {
        this.elm.forEach((elm) => {
            var inputs = elm.querySelectorAll("input");
            var textareas = elm.querySelectorAll("textarea");
            inputs.forEach((input) => {
                input.value = "";
            });
            textareas.forEach((textarea) => {
                textarea.value = "";
            });
        });
    }
    find(sel) {
        const query1 = [...this.getElm().querySelectorAll(sel)];
        const query2 = [...this.getElm().querySelectorAll(`[class*="${sel}"]`)];
        const query3 = [...this.getElm().querySelectorAll(`[id*="${sel}"]`)];
        const query = query1.concat(query2.concat(query3));
        const x = $DOM();
        x.elm = query;
        return x;
    }
}


function DOMUtils(elm) {
    return new _DOMUtils(elm);
}



export {
    HttpRequest,
    DOMUtils,
    escapeHtml,
}